import Loading from '../../../components/Loading/Loading';
import React, { FC } from 'react';
import { LibraryWithAnyData } from '../../../components/Library/LibraryWithAnyData';
import { TopNavigation } from '../../../components/TopNavigation/TopNavigation';
import { concatPath } from '../../../utils/links/concatPath';
import { dashboardKey, dashboardStackKey, privateKey } from '../../../constants/routeKeys';
import { observer } from 'mobx-react';
import { router, useGlobalSearchParams, useScrollToTop } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStores } from '../../../hooks/useStores';





const ChooseNewPath: FC = observer(() => {
  const rootStore = useStores();
  const params = useGlobalSearchParams();

  const data = rootStore?.categories.categoriesFormatedForChooseANewPath;
  const labels = rootStore?.language.translate.MOBILE.CHOOSE_NEW_PATH;
  const insets = useSafeAreaInsets();

  const ref = React.useRef(null);
  useScrollToTop(ref);




  const goBack = () => {
    if(router.canGoBack()){
      router.back();
    } else {
      router.navigate(concatPath([privateKey, dashboardStackKey, dashboardKey], -1) as string);
    }
  };


  const renderHeader = () => {
    return( <TopNavigation title={labels?.HEADER} onPressLeft={goBack} style={{marginTop:insets.top}}
      onboarding={false}/>
    );
  };

  if ( !data || !(data.length > 0)) {
    return (
      <Loading
        withLabel={false}
      />
    );
  }



  return (
    <LibraryWithAnyData data={data} header={renderHeader} filterOutId={params?.filterOutId as string} displayButtonBelow={true}/>
  );
});

export default ChooseNewPath;
